import './targets.less';
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import SelectField from '../../../../shared/form-elements/select/field';
import InputField from '../../../../shared/form-elements/input';
import { getCurrencyIcon } from '../../../../../../../shared/js/get-currency-icon';
import isNull from 'lodash/isNull';
import flatten from 'lodash/flatten';
import find from 'lodash/find';
import cn from 'classname';

const SelectFieldWithFlag = props => {
	return (
		<div>
			<SelectField {...props}>
				<span className={`select-image select-image__flag flag-icon flag-icon-${props.countryCode.toLowerCase()}`} />
				{props.shouldShowBoostIcon && <span className="boost-icon" />}
			</SelectField>
		</div>
	);
};

SelectFieldWithFlag.propTypes = {
	countryCode: PropTypes.string,
	shouldShowBoostIcon: PropTypes.bool
};

const Targets = props => {
	if (props.fields.length === 0) return null;
	return (
		<tr className="targets-form__wrap">
			<td colSpan={5}>
				<table className="targets-form__table">
					<thead className="entity-wrap__table-head">
						<tr>
							<th className="location">
								<span>{props.intl('Geo')}</span>
							</th>
							{props.payoutCurrencies.map((currency, index) =>
								<th className="price" key={index}>
									<span>{props.intl('Payout %s', `, ${getCurrencyIcon(currency)}`)}</span>
								</th>
							)}
						</tr>
					</thead>
					<tbody className="entity-wrap__table-body">
						{flatten(
							props.fields.map((parentName, index, fields) => {
								const target = fields.get(index);
								const shouldDisablePayoutInputs = target && (target.status !== 'active' && !isNull(target.amount));

								const countryCode = target.country_code || '';
								const masterTarget = target.masterTarget;
								const payoutDiff = getPayoutDiff(target, masterTarget);

								const offerId = target.offer_id;
								const locationId = target.location_id && target.location_id[0] && target.location_id[0]['value'];
								const affiliateId = target.affiliate_id;

								const wasBoostNullified = !!find(props.nullifiedBoosts, { offerId, locationId, affiliateId });

								return [
									<tr
										key={index}
										className={cn({
											'entity-aff-form-target': true,
											'last-target': index === fields.length - 1
										})}
									>
										<td className="location">
											<div className="ui-form__element location__field">
												<Field
													name={`${parentName}.location_id`}
													placeholder=""
													component={SelectFieldWithFlag}
													countryCode={countryCode}
													shouldShowBoostIcon={!wasBoostNullified && target.boost_till !== null}
													disabled={true}
													searchable={false}
													multi={false}
													showLabel={false}
													options={[]}
												/>
											</div>
										</td>
										{props.payoutCurrencies.map((currency, index) =>
											<td className={`price ${index > 0 ? 'last' : ''}`} key={index}>
												<div
													className={`ui-form__element ${payoutDiff[currency] && payoutDiff[currency].className}`}
												>
													<Field
														name={`${parentName}.${currency}`}
														placeholder={payoutDiff.usd.masterAmount || ''}
														component={InputField}
														showLabel={false}
														disabled={shouldDisablePayoutInputs}
														onChange={() => props.nullifyBoostOnSubmit({ offerId, locationId, affiliateId })}
													/>
												</div>
											</td>
										)}
									</tr>,
									<tr key={`targets-padding-${index}`} className="padding-tr" />
								];
							})
						)}
					</tbody>
				</table>
			</td>
		</tr>
	);
};

const getPayoutDiff = (field, masterTarget) => {
	const calcDiff = currency => {
		const masterAmount = (masterTarget && parseInt(masterTarget[currency])) || 0;
		const childAmount = (field && parseInt(field[currency])) || 0;

		return masterTarget && field && childAmount !== masterAmount
			? { className: 'payout-diff', masterAmount: masterAmount.toString() }
			: { className: '', masterAmount: null };
	};

	return {
		rub: calcDiff('rub'),
		eur: calcDiff('eur'),
		usd: calcDiff('usd')
	};
};

Targets.propTypes = {
	fields: PropTypes.object,
	nullifyBoostOnSubmit: PropTypes.func,
	nullifiedBoosts: PropTypes.array,
	intl: PropTypes.func
};

export default Targets;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/affiliates/targets.js